<template>
  <div class="card-body">
      <h5 class="card-title">Iskanje naprav</h5>
      <div class="input-group mb-3">
        <input type="text" class="form-control" placeholder="Vnesi del imena ali serijsko številko" v-model="query" aria-label="Iskanje naprav">
        <span class="input-group-btn">
          <button type="button" class="btn btn-secondary" @click="query = ''">🗙</button>
        </span>
      </div>
      <ul class="list-group list-group-flush" v-if="devices.length > 0">
        <li class="list-group-item" v-for="d in devices" :key="d.id">
          <a href="#" @click.prevent="$router.push({ name: 'DeviceEdit', params: { deviceId: d.id } })">{{ d.label }} ({{ d.deviceNumber }})</a>
        </li>
      </ul>
      <div v-else-if="query.length > 0">Ni najdenih naprav</div>
      <button class="btn btn-outline-secondary btn-sm mb-3" @click="showBarcode = true" v-show="!showBarcode">Pokaži iskalnik s črtno kodo</button>
      <Barcode @detected="searchAsync" v-if="showBarcode" />
  </div>
</template>

<script setup>
import { ref, toRef, toRefs, computed, defineComponent, watch, reactive, onMounted, inject, onBeforeUnmount } from "vue"
import { searchDevicesAsync } from "scripts/api"
import Barcode from "./Barcode.vue"
import { useAuth } from "scripts/composition-api/useAuth"

defineOptions({ name: "DevicesCard" })

const router = VueRouter.useRouter()
const { fetchAuthAsync } = useAuth()
const devices = ref([])
const query = ref("")
let debounceTimer = null
const showBarcode = ref(false)

const searchAsync = async (bc) => {
  if (bc?.ident) query.value = bc.ident
  devices.value = await searchDevicesAsync(fetchAuthAsync, query.value)
  if (devices.value.length === 1) {
    router.push({ name: "DeviceEdit", params: { deviceId: devices.value[0].id } })
  }
}

const stopWatch = watch(query, (newVal, oldVal) => {
  if (debounceTimer) clearTimeout(debounceTimer)
  debounceTimer = setTimeout(() => {
    if ((newVal || "").length > 2) {
      searchAsync()
    } else {
      devices.value = []
    }
  }, 300)
})

onBeforeUnmount(() => {
  if (debounceTimer) clearTimeout(debounceTimer)
  if (stopWatch) stopWatch()
})
</script>
